export default "__VITE_ASSET__cVatZ$ln__"